const Guid = 'TEMPLATE_ASSET_GUID';
const AssetGuid = `assets-${Guid}`;
export { AssetGuid, Guid };
